import { QuestionSchemaType, zodButtonOptions } from "./surveyStatusSchemas";

/**
 * Helper functions for survey section
 */
export function nextQuestionIdOrConclusion(question: QuestionSchemaType, response: string): string {
    let nextQuestionId: string | undefined = "";
    switch(question.type) {
        case 'YesNo':
        case 'YesNoDontKnow':
        case 'YesNA':
            if (response == zodButtonOptions.enum.YES)
                nextQuestionId = question.flow.yes;
            if (response == zodButtonOptions.enum.NO)
                nextQuestionId = question.flow.no;
            if (response == zodButtonOptions.enum.DONT_KNOW)
                nextQuestionId = question.flow.dontKnow;
            if (response == zodButtonOptions.enum.NA)
                nextQuestionId = question.flow.na;
            break;
        case 'FreeText':
        case 'Number':
        case 'DropDown':
            nextQuestionId = question.flow.next;
    };
    return nextQuestionId || "UNDEFINED";
} 